[
  {
    "id": "reflow.batch",
    "label": ["Review mature pages", "效果复盘"],
    "input_schema": {
      "type": "object",
      "properties": {
        "locale": {
          "type": "string",
          "enum": ["en", "zh"]
        }
      },
      "required": ["locale"],
      "additionalProperties": false
    }
  },
  {
    "id": "draft.batch",
    "label": ["Draft selected directions", "批量起草"],
    "input_schema": {
      "type": "object",
      "properties": {
        "pages": {
          "type": "array",
          "maxItems": 100,
          "items": {
            "type": "object",
            "properties": {
              "recipe": {
                "type": "string",
                "enum": ["entity.enrich", "faq.clarify", "vs.generate", "alternatives.generate"]
              },
              "gap_id": {
                "type": "string",
                "minLength": 1
              }
            },
            "required": ["recipe", "gap_id"],
            "additionalProperties": true
          }
        },
        "locale": {
          "type": "string",
          "enum": ["en", "zh"]
        },
        "quality": {
          "type": "string",
          "enum": ["standard", "deep"]
        },
        "daily": {
          "type": "boolean"
        }
      },
      "required": ["pages", "locale", "quality"],
      "additionalProperties": false
    }
  },
  {
    "id": "publish.batch",
    "label": ["Publish approved revisions", "发布已批准版本"],
    "input_schema": {
      "type": "object",
      "properties": {
        "pages": {
          "type": "array",
          "maxItems": 100,
          "items": {
            "type": "object",
            "properties": {
              "page_id": {
                "type": "string",
                "minLength": 1
              },
              "revision": {
                "type": "integer",
                "minimum": 1,
                "maximum": 2147483647
              }
            },
            "required": ["page_id", "revision"],
            "additionalProperties": false
          }
        },
        "locale": {
          "type": "string",
          "enum": ["en", "zh"]
        },
        "block_dirty_facts": {
          "type": "boolean"
        },
        "before_batches": {
          "type": "array",
          "maxItems": 50,
          "items": {
            "type": "object",
            "properties": {
              "batch_id": {
                "type": "string",
                "minLength": 1
              }
            },
            "required": ["batch_id"],
            "additionalProperties": true
          }
        }
      },
      "required": ["pages", "locale", "block_dirty_facts", "before_batches"],
      "additionalProperties": false
    }
  },
  {
    "id": "distribution.batch",
    "label": ["Distribute published pages", "分发已发布页面"],
    "input_schema": {
      "type": "object",
      "properties": {
        "pages": {
          "type": "array",
          "maxItems": 100,
          "items": {
            "type": "object",
            "properties": {
              "page_id": {
                "type": "string",
                "minLength": 1
              },
              "revision": {
                "type": "integer",
                "minimum": 1,
                "maximum": 2147483647
              }
            },
            "required": ["page_id"],
            "additionalProperties": false
          }
        },
        "channels": {
          "type": "array",
          "maxItems": 10,
          "items": {
            "type": "object",
            "properties": {
              "platform": { "type": "string", "minLength": 1 },
              "format": { "type": "string" },
              "credential_id": { "type": "string" },
              "target_url": { "type": "string" },
              "fields": {
                "type": "object",
                "additionalProperties": { "type": "string" }
              }
            },
            "required": ["platform"],
            "additionalProperties": false
          }
        },
        "image_model": { "type": "string" },
        "preset": {
          "type": "string",
          "enum": ["square", "portrait", "vertical", "landscape"]
        }
      },
      "required": ["pages"],
      "additionalProperties": false
    }
  }
]
